import React from 'react';
import './Skills.css';

const Skills = ({ skills }) => {
  return (
    <div className="skills">
      {skills.map((skill, index) => {
        const { label, text } = skill;
        return (
          <p key={index} className="skills-line">
            <strong className="skills-label">{label}</strong>: {text}
          </p>
        )
      })}
    </div>
  );
};

export default Skills;
